import { useLocation } from '@tanstack/react-router'
import { ThemeProvider } from 'next-themes'
import { PropsWithChildren } from 'react'

import { DocumentPreviewProvider } from '@/contexts/document-preview-context'
import { FirebaseUserContextProvider } from '@/hooks/useFirebaseUser'
import { useLocaleSync } from '@/hooks/useLocaleSync'
import { initI18n } from '@/i18n'
import { useDateFnsConfiguration } from '@/integrations/date-fns'
import { useZodLocale } from '@/integrations/zod'

import { QueryProvider } from './QueryProvider'
import { ReduxProvider } from './ReduxProvider'

initI18n()

const InnerProviders = ({ children }: PropsWithChildren) => {
  useLocaleSync()

  return children
}

export const Providers = ({ children }: PropsWithChildren) => {
  useZodLocale()
  useDateFnsConfiguration()
  const location = useLocation()

  return (
    <ThemeProvider
      attribute="class"
      enableSystem={false}
      forcedTheme={location.pathname.startsWith('/login') ? 'light' : undefined}
    >
      <ReduxProvider>
        <InnerProviders>
          <QueryProvider>
            <FirebaseUserContextProvider>
              <DocumentPreviewProvider>{children}</DocumentPreviewProvider>
            </FirebaseUserContextProvider>
          </QueryProvider>
        </InnerProviders>
      </ReduxProvider>
    </ThemeProvider>
  )
}
